import React from 'react';
export default class Example extends React.Component {
    render() {
        return (<div className="banner">
                <div className="banner__background">
                    <div />
                </div>
                <div className="banner__foreground px-8 py-8">
                    <div className="d-flex align-items-center justify-content-center h-100">
                        <div className="text-white text-center">
                            <div className="banner__title">650x330</div>
                            <div className="banner__subtitle">Výpis kategorie, stránka gratulace a moje kurzy</div>
                        </div>
                    </div>
                </div>
            </div>);
    }
}
